import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { VendorStatusItem } from 'src/app/services/vendor-roles.service';

@Component({
  standalone: true,
  selector: 'app-status-tooltip',
  template: `
    <div class="relative inline-block cursor-default" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave()">
      <span class="inline-flex items-center gap-1 text-[13px] text-blue-700">
        {{ visibleStatusIds().size }} / {{ allStatuses().length }}
        <mat-icon class="info-icon text-blue-gray-300">info_outline</mat-icon>
      </span>
    </div>

    @if (visible) {
    <div class="status-tooltip" [style.top.px]="tooltipY" [style.left.px]="tooltipX">
      @for (status of allStatuses(); track status.id) {
      <div class="flex items-center gap-1.5 py-0.5">
        @if (visibleStatusIds().has(status.id)) {
        <mat-icon class="tooltip-icon text-green-800">check_circle</mat-icon>
        } @else {
        <mat-icon class="tooltip-icon text-red-800">cancel</mat-icon>
        }
        <span class="text-xs text-gray-700 whitespace-nowrap">{{ status.labelForStatus }}</span>
      </div>
      }
    </div>
    }
  `,
  styles: [
    `
      .info-icon {
        font-size: 16px;
        width: 16px;
        height: 16px;
      }
      .tooltip-icon {
        font-size: 14px;
        width: 14px;
        height: 14px;
      }
      .status-tooltip {
        position: fixed;
        z-index: 10000;
        min-width: 220px;
        max-width: 300px;
        padding: 8px 10px;
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        pointer-events: none;
      }
    `,
  ],
  imports: [CommonModule, MatIconModule],
})
export class StatusTooltipComponent {
  allStatuses = input<VendorStatusItem[]>([]);
  visibleStatusIds = input<Set<number>>(new Set());

  visible = false;
  tooltipX = 0;
  tooltipY = 0;

  onMouseEnter(event: MouseEvent): void {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.tooltipX = rect.left;
    this.tooltipY = rect.bottom + 4;
    this.visible = true;
  }

  onMouseLeave(): void {
    this.visible = false;
  }
}
